<div
  class="card d-flex flex-column py-2 justify-content-between align-items-center"
  style="height: 5.2rem"
>
  <div class="mx-1 px-3" style="width: 4rem; height: 4rem">
    <img src="{{ image }}" class="w-100 h-100" style="object-fit: cover" />
  </div>
  <h3 class="my-auto mx-auto h4">{{ counter?.toString() }}</h3>
</div>
